export const LESSON_PREFIX = "lesson"
